module.exports = __webpack_public_path__ + "sa.svg?e5a120b5d06e90050eee5c658308e811";